import Cookies from 'js-cookie'

import { isProduction, isStaging } from './environment'

window.ScarabQueue = window.ScarabQueue || []

function emarsys(data = {}) {
  if (!isProduction() && !isStaging()) {
    ScarabQueue.push(['testMode'])
  }

  const { category, purchase, view } = data
  const cart = data.cart || Cookies.getJSON('emarsysCartData') || []
  const inThirtyMinutes = 1 / 48

  Cookies.set('emarsysCartData', cart, {
    expires: inThirtyMinutes,
    samesite: "lax"
  })

  if (view) {
    ScarabQueue.push(['view', view])
  }

  if (category) {
    ScarabQueue.push(['category', category])
  }

  if (purchase) {
    Cookies.remove('emarsysCartData')
    ScarabQueue.push(['cart', []])
    ScarabQueue.push(['purchase', purchase])
  } else {
    ScarabQueue.push(['cart', Cookies.getJSON('emarsysCartData')])
  }

  ScarabQueue.push(['go'])
}

export default emarsys



// WEBPACK FOOTER //
// ./shared/helpers/emarsys.js